module.exports = __webpack_public_path__ + "img/1F631.55515cf9.svg";